import Logo from '@assets/images/logo-voluntarios.svg';

import { Section } from '@layouts/Section/Section';
import { Container } from '@layouts/Container/Container';
import {
  Dropdown,
  DropdownTrigger,
  DropdownContent,
  DropdownItem,
} from '@acb_devel/design-system';
import { Button } from '@acb_devel/design-system';
import { AngleDownIcon } from '@acb_devel/design-system';
import { LogoutIcon } from '@acb_devel/design-system';
import { useUserContext } from '@contexts/UserContext';
import { useAuthContext } from '@contexts/AuthContext';

import styles from './Navbar.module.scss';

export function Navbar({
  showProfileDropdown = true,
}: {
  showProfileDropdown?: boolean;
}) {
  const { user } = useUserContext();
  const { logout } = useAuthContext();

  return (
    <Section as="header">
      <nav className={styles.navbar}>
        <Container className={styles.navbar__container}>
          <img
            src={Logo}
            alt="Logo Voluntarios acb"
            className={styles.navbar__logo}
          />
          {showProfileDropdown && (
            <Dropdown>
              <DropdownTrigger asChild>
                <Button color="accent">
                  {user?.profile?.firstName && (
                    <>
                      ¡Hola {user?.profile?.firstName}! <AngleDownIcon />
                    </>
                  )}
                  {!user?.profile?.firstName && (
                    <>
                      ¡Hola! <AngleDownIcon />
                    </>
                  )}
                </Button>
              </DropdownTrigger>
              <DropdownContent>
                <DropdownItem onClick={logout}>
                  <LogoutIcon /> Cerrar sesión
                </DropdownItem>
              </DropdownContent>
            </Dropdown>
          )}
        </Container>
      </nav>
    </Section>
  );
}
